import Repository from '@/repositories/RepositoryFactory';
import APISTATE from '../../enums/APISTATE';
import moment, { ISO_8601 } from "moment";

const reports = Repository.get('reports');
const emptyUserDriveData = {
    id: 0,
    assistant_Name: '',
    type: 21,
    subType: 'DT',
    days: 0,
    timeInMinutes: 0,
    remark: '',
    distance: 0,
    createdDate: new Date(),
    chr: '',
    approvedBy: '',
    approvedByUser: false,
    totalImposed: 0,
    totalPreliminaryInvestigations: 0,
    totalPreliminaryInvestigationsDonor: 0,
    vgProject: false,
    vainVisits: 0,
    onDayOff: false
}

const getDateFromMonthYear = (day, month, year) =>  {
    let date = new Date();
    date.setMonth(month);
    date.setFullYear(year);
    date.setDate(day);
    date.setHours(3);
    return date;
  };

export default {
    namespaced: true,
    state: {
        report: [],
        apiState: APISTATE.LOADED,
        employeeNumber: undefined,
        employeeId: undefined,
        employeeName: undefined,
        year: undefined,
        month: undefined,
        selectedUserDriveData: undefined,
        types: [{id: 21, title:'ATK', backgroundColor: 'white'}, {id: 22, title: 'RTA', backgroundColor: 'white'}]
    },
    mutations: {
        setReport (state, open){
            state.report = open
        },
        setApiState(state, apiState){
            state.APISTATE = apiState;
        },
        setYear(state, year){
            state.year = year;
        },
        setMonth(state, month){
            state.month = month;
        },
        setEmployeeNumber(state, employeeNumber) {
            state.employeeNumber = employeeNumber;
        },
        setSelectedUserDriveData(state, data){
            state.selectedUserDriveData = data;
        },
        setSelectedType(state, type){
            const typeData = state.types.find(t => t.id == type);
            state.selectedUserDriveData.type = typeData.id;
            state.selectedUserDriveData.typeStringified = typeData.title;
        },
        setEmployeeId(state, id){
            state.employeeId = id;
        },
        setEmployeeName(state, name){
            state.setEmployeeName = name;
        }
    },
    actions: {
        async performLookup({commit, state})  {
            commit("setApiState", APISTATE.LOADING);
            let report = await reports.getDTReport(state.employeeNumber, state.year, state.month + 1);
            commit("setReport", report);
            commit("setApiState", APISTATE.LOADED);
        },
        setYear({commit}, year) {
            commit("setYear", year);
        },
        setMonth({commit}, month) {
            commit("setMonth", month);
        },
        setEmployeeNumber({commit}, employeeNumber) {
            commit("setEmployeeNumber", employeeNumber);
        },
        setSelectedUserDriveData({commit}, data){
            data.createdDate = new Date(data.createdDate);
            commit("setSelectedUserDriveData", data);
        },
        setNewUserDriveData({commit, state}, currentUser){
            const newUserDriveData = emptyUserDriveData;
            newUserDriveData.assistant_Number = state.employeeNumber;
            newUserDriveData.assistant_Name = state.employeeName;
            newUserDriveData.assistant_Uid = state.employeeId;
            newUserDriveData.approvedBy = currentUser.name;
            newUserDriveData.remark = 'DT';
            commit("setSelectedUserDriveData", newUserDriveData);
        },
        setEmployeeId({commit}, id){
            commit("setEmployeeId", id);
        },
        cancelSidebar({commit}){
            commit("setSelectedUserDriveData", undefined);
        },
        async update({commit, state}){
            commit("setApiState", APISTATE.LOADING);
            state.selectedUserDriveData.assistant_Number = state.selectedUserDriveData.assistant_Number.toString();
            const date = state.selectedUserDriveData.createdDate;
            state.selectedUserDriveData.createdDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
            reports.updateDTReport(state.selectedUserDriveData).then( async function (){
                let report = await reports.getDTReport(state.employeeNumber, state.year, state.month + 1);
                commit("setReport", report);
                commit("setSelectedUserDriveData", undefined);
            });
            
            commit("setApiState", APISTATE.LOADED);
        },
        setSelectedType({commit}, type){
            commit("setSelectedType",type)
        },
        setEmployeeName({commit}, name){
            commit("setEmployeeName", name);
        },
        async deleteItem({commit, state}){
            commit("setApiState", APISTATE.LOADING);
            reports.deleteDTReport(state.selectedUserDriveData.id).then(async function(){
                let report = await reports.getDTReport(state.employeeNumber, state.year, state.month + 1);
                commit("setReport", report);
                commit("setSelectedUserDriveData", undefined);
            });
            commit("setApiState", APISTATE.LOADED);
        }
    },
    getters: {
        report: (state) => { return state.report },
        year: (state) => { return state.year},
        month: (state) => { return state.month },
        employeeNumber: (state) => { return state.employeeNumber },
        loading: (state) => { return state.apiState !== APISTATE.LOADED  },
        showSidebar: (state) => { return state.selectedUserDriveData !== undefined },
        sidebarHeaderText: (state) => { return state.selectedUserDriveData?.id !== 0 ? "Opdater" : "Opret" },
        selectedUserDriveData: (state) => { return state.selectedUserDriveData },
        types: (state) => { return state.types }
    }
}